import React, { Suspense } from 'react';
import { Route, Routes,Navigate } from 'react-router-dom';
import LoadingComponent from './components/loading';
import SLUGS from './resources/slugs';
import Subscription from '../Subscription/Subscription'
import sidebar from './components/sidebar/SidebarComponent'
import Profile from '../profile/index'
import Reports from '../../components/cusreports/index'
function PrivateRoutes() {
  return (
    <Suspense fallback={<LoadingComponent loading />}>
      <Routes>
        <Route  path={SLUGS.subscription} element={<Subscription/>} />
        <Route  path={SLUGS.profile} element={<Profile/>} />
        <Route  path={SLUGS.reports} element={<Reports/>} />
        <Route render={() => <Navigate to="/subscription" />} />
      </Routes>
    </Suspense>
  );
}

export default PrivateRoutes;
